module.exports = __webpack_public_path__ + "assets/stuff-4.52dc3253.svg";